import React from 'react';
import { Accordion as MantineAccordion } from '@mantine/core';

export interface AccordionItemProps {
	value?: string;
	header: React.ReactNode;
	children: React.ReactNode;
}

interface AccordionProps extends AccordionItemProps {
	isOpen?: boolean;
	onToggle?: () => void;
}

export const Accordion: React.FC<React.PropsWithChildren<AccordionProps>> = ({
	isOpen = false,
	onToggle,
	value = 'title',
	header,
	children,
}) => {
	return (
		<MantineAccordion variant="contained" value={isOpen ? value : null} className="accordion-control">
			<MantineAccordion.Item value={value}>
				<MantineAccordion.Control className="accordion-header" onClick={onToggle}>
					{header}
				</MantineAccordion.Control>
				<MantineAccordion.Panel className="accordion-body">{children}</MantineAccordion.Panel>
			</MantineAccordion.Item>
		</MantineAccordion>
	);
};

export default Accordion;
